import { render, staticRenderFns } from "./LoginIcon.vue?vue&type=template&id=a27b0152&"
import script from "./LoginIcon.vue?vue&type=script&lang=js&"
export * from "./LoginIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports